<template>
  <div class="investment_warp">
    <SearchHunt
      :filterData="filterData"
      @handle_seach="handle_seach"
      @handle_freeze="handle_freeze(selectedRows,1)"
      @handle_thaw="handle_thaw(selectedRows,1)"
      @handle_giveBenefits="handle_giveBenefits(selectedRows,1)"
      ref="SearchHunt"
    />
    <a-table
      class="antd-table"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange,columnWidth: '40px'}"
      bordered
      :columns="relevanceBatch_grid.field"
      :data-source="relevanceBatch_grid.row"
      rowKey="id"
      size="small"
      :scroll="{ y: relevanceBatch_grid.height,x:relevanceBatch_grid.width}"
      :pagination="false"
      :loading="tableLoading"
    >
      <!-- 序号 -->
      <span slot="index" slot-scope="text, record, index">
        {{index + (pageParam.pageNum-1) * pageParam.pageSize + 1}}
      </span>
      <!-- 客户状态 -->
      <span slot="custStatus" slot-scope="text, record">
        <span v-if="record.custStatus == '01'"><a-badge color="gold" /></span>
        <span v-else-if="record.custStatus == '02'"><a-badge color="cyan" /></span>
        <span v-else-if="record.custStatus == '03'"><a-badge color="red"/></span>
        {{ text | DictionaryFilter('CUST_STATUS') }}
      </span>
      <!-- 在线状态 -->
      <span slot="onlineStatus" slot-scope="text, record">
        {{ text | DictionaryFilter('YES_NO') }}
      </span>
      <!-- 更多操作 -->
      <span slot="operation" slot-scope="data" class="ellipsis">
        <!-- 正常 -->
        <div v-if="data.custStatus == '01' || data.custStatus == '02'">
          <a @click="handle_freeze(data,2)">冻结</a>
        </div>
         <!-- 冻结 -->
         <div v-if="data.custStatus == '03'">
          <a  @click="handle_thaw(data,2)">解冻</a>
        </div>
      </span>
    </a-table>

    <!-- 底部 -->
    <div class="table_bottom">
      <!-- 按钮 -->
      <!-- <div class="bottom_btn">
        <a-button type="primary" @click="handle_all" class="btn_first">选择全部</a-button>
        <a-button type="primary" ghost  @click="handle_reverse">反向选择</a-button>
      </div> -->

      <!-- 分页 -->
      <div>
        <a-pagination
          class="table_pagination"
          show-size-changer
          :default-current="1"
          v-model="pageParam.pageNum"
          :show-total="(total) => `共 ${total} 条`"
          :page-size-options="pageSizeOptions"
          size="small"
          :total="total"
          @showSizeChange="onShowSizeChange"
          @change="paginationChange"
          :page-size.sync="pageParam.pageSize"
        />
      </div>
    </div>
    <!-- 表单 -->
    <!-- 解冻/冻结 -->
    <operateModal
      v-if="operateVisible" 
      :modalTitle="operateTitle"
      :modalContent="operateContent"
      @close="close" 
      @handleOk="operatelHandleOk"
    >
    </operateModal>
  </div>
</template>

<script>
import {
  queryCustom,
  lockCusUser,
  unlockCusUser,
  giveGood
} from "@/api/api.js";
import moment from "moment";
import SearchHunt from "./components/search-hunt/search-hunt.vue";
import operateModal from "./components/modal-hunt/operate-modal.vue";
import { DictionaryService } from "@common/services/dictionary.service";
export default {
  name: "",
  components: {
    SearchHunt,
    operateModal
  },
  data() {
    return {
      //搜索栏
      filterData: [
        {
          name: "custName",
          type: "input",
          value: undefined,
          label: "请输入客户姓名",
          placeholder:"客户姓名：",
        },
        {
          name: "custNo",
          type: "input",
          value: undefined,
          label: "请输入客户编号",
          placeholder:"客户编号：",
        },
      ],
      relevanceBatch_grid: {
        height: "calc(100vh - 250px)",
        width: 0, // 宽度
        row: [],
        field: [
          {
            title: "序号",
            align: "center",
            width: 50,
            dataIndex: "index",
            ellipsis: true,
            scopedSlots: {
              customRender: "index",
            },
          },
          {
            title: "客户编号",
            align: "center",
            width: 90,
            dataIndex: "custNo",
            ellipsis: true,
          },
          {
            title: "客户姓名",
            align: "center",
            width: 170,
            dataIndex: "custName",
            ellipsis: true,
          },
          {
            title: "客户状态",
            align: "center",
            width: 80,
            dataIndex: "custStatus",
            ellipsis: true,
            scopedSlots: {
              customRender: "custStatus",
            },

          },
          {
            title: "绑定手机号",
            colSpan: 1,
            width: 120,
            dataIndex: "phoneNo",
            align: "center",
            ellipsis: true,
          },
          {
            title: "最后消费时间",
            colSpan: 1,
            align: "center",
            width: 150,
            ellipsis: true,
            dataIndex: "recentConsumeDate",
            scopedSlots: {
              customRender: "cstTp",
            },
            // customRender: (text, row, index) => {
            //   // this.cstTpList.forEach((item) => {
            //   //   console.log(item.value,"item",text)
            //   //   if (item.value == text) {
            //   //     return item.label;
            //   //   }
            //   // })
            //   // console.log("text | DictionaryFilter('CST_TP')",text | DictionaryFilter('CST_TP'))
            //   // return text | DictionaryFilter('CST_TP');
            // }
          },
          {
            title: "最后消费金额",
            colSpan: 1,
            align: "center",
            width: 100,
            ellipsis: true,
            dataIndex: "recentConsume",
          },
          {
            title: "注册日期",
            colSpan: 1,
            align: "center",
            width: 150,
            ellipsis: true,
            dataIndex: "createTime"
          },
          {
            title: "操作",
            width: 100,
            align: "center",
            scopedSlots: {
              customRender: "operation",
            },
          },
        ]
      },
      pageParam: {
        pageNum: 1,
        pageSize: 10,
        orderBy: ""
      },
      pageSizeOptions: ["10", "20", "50", "100"],
      total: 0,
      selectedRowKeys: [],
      paramsObj: {
        custName: null,
        custNo: null,
      },
      list: [],
      selectedRows:[],//多选数据
      //批量审核弹窗
      operateVisible: false,
      operateTitle:"",
      operateContent: [],
      operateData:[],
      //再次确认弹窗
      secondConfirmVisible: false,
      secondConfirmTitle: "",
      secondConfirmContent: "",
      secondConfirmData:[],
      //客户状态
      cstTpList:[],
      onlineStatusList: [],
      //查询加载
      tableLoading:false,
      
    };
  },
  mounted() {
    // 获取字典
    DictionaryService.getAllNeedDic(["CUST_STATUS", "YES_NO"]).then((res) => {
      //客户类型
      this.cstTpList = DictionaryService.getOptions("CUST_STATUS");
      //在线状态
      this.onlineStatusList = DictionaryService.getOptions("YES_NO");

       //查询
      this.queryList();
    }); 
    this.relevanceBatch_grid.width = 0;
    this.relevanceBatch_grid.field.map(item => {
      this.relevanceBatch_grid.width += item.width;
    });
  },
  methods: {
    paginationChange(page, pageSize) {
      this.pageParam.pageNum = page;
      this.queryList();
    },
    onShowSizeChange(current, size) {
      this.pageParam.pageSize = size;
      this.pageParam.pageNum = 1;
      this.queryList();
    },
    onSelectChange(data, selectedRows) {
      this.selectedRows = selectedRows;
      this.selectedRowKeys = data;
    },
    // 查询
    handle_seach(params) {
      this.paramsObj = params;
      this.pageParam.pageNum = 1;
      this.queryList();
    },
    queryList() {
      this.tableLoading = true;
      queryCustom({
        pageParam: {
          pageNum: this.pageParam.pageNum,
          pageSize: this.pageParam.pageSize,
          orderBy: ""
        },
        content: this.paramsObj
      }).then(
        (res) => {
          if (res.content.rows && res.content.rows.length) {
            this.relevanceBatch_grid.row = res.content.rows;
            this.total = res.content.page.totalRows;
          } else {
            this.relevanceBatch_grid.row = [];
            this.total = 0;
          }
          this.tableLoading = false;
        },
        (error) => {
          this.tableLoading = false;
        });
    },
    //冻结
    handle_freeze(data,type) {
      // 1批量  2非批量
      if (type == 1) {
        if (this.selectedRowKeys && !this.selectedRowKeys.length) {
          return this.$message.warning("请先选中一条数据！");
        } else {
          this.operateData = this.selectedRows;
        }
      } else {
        this.operateData.push(data);
      }
      let idList = [];
      this.operateData.forEach((item) => {
        idList.push(item.id);
      });
      this.$confirm({
        title: "请确认是否需要冻结?",
        okText: "是",
        cancelText: "否",
        onOk: () => {
          lockCusUser({ ids: idList }).then(
            (res) => {
              this.operateData = [];
              this.queryList();
              this.$message.success("操作成功！");
              this.selectedRowKeys = [];
              this.selectedRows = [];
            },
            (err) => {
              this.operateData = [];
              this.$message.success("操作失败！");
            }
          );
        },
        onCancel: () => {},
      });
    },
    //解冻
    handle_thaw(data, type) {
      // 1批量  2非批量
      if (type == 1) {
        if (this.selectedRowKeys && !this.selectedRowKeys.length) {
          return this.$message.warning("请先选中一条数据！");
        } else {
          this.operateData = this.selectedRows;
        }
      }else {
        this.operateData.push(data);
      }
      let idList = [];
      this.operateData.forEach((item) => {
        idList.push(item.id);
      });
      this.$confirm({
        title: "请确认是否需要解冻?",
        okText: "是",
        cancelText: "否",
        onOk: () => {
          unlockCusUser({ ids: idList }).then(
            (res) => {
              this.operateData = [];
              this.queryList();
              this.$message.success("操作成功！");
              this.selectedRowKeys = [];
              this.selectedRows = [];
            },
            (err) => {
              this.operateData = [];
              this.$message.success("操作失败！");
            }
          );
        },
        onCancel: () => {},
      });
    },
    //赠送权益
    handle_giveBenefits(data,type) {
      // 1批量  2非批量
      if (type == 1) {
        if (this.selectedRowKeys && !this.selectedRowKeys.length) {
          return this.$message.warning("请先选中一条数据！");
        }
      }
      let sf = true;
      this.selectedRows.forEach(item => {
        if (item.custStatus == '03') {
          sf = false;
          return this.$message.warning("有客户处于【冻结】状态，不可赠送权益，请重新选择！");
        }
      });
      if (sf == true) {
        this.operateVisible = true;
        this.operateTitle = "赠送权益";
        this.operateContent = this.selectedRows; 
      }
    },
    //弹窗关闭
    close() {
      this.operateVisible = false;
    },
    //弹窗确认
    operatelHandleOk(data) {
      //客户ID集合
      let custIdlist = [];
      this.selectedRows.forEach(item => {
        custIdlist.push(item.id);
      })

      //商品集合
      let goodList = [];
      data.forEach(item => {
        goodList.push(
          {
            goodsInfoId: item.id,
            num: item.number,
          }
        )
      })
 
      giveGood({
        custIds : custIdlist,
        goods :goodList
      }).then(
        (res) => {
          if (res.code == '0000') {
            this.$message.success('赠送权益成功！');
            this.operateVisible = false;
            this.queryList();
            this.selectedRowKeys = [];
            this.selectedRows = [];
          }
        },
        (err) => {
          this.$message.error('赠送权益失败！');
          this.operateVisible = false;
        })
    },
  },
};
</script>

<style scoped lang="less">
.select_width {
  width: 180px !important;
}
.ellipsis {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.investment_flex {
  display: flex;
  margin-bottom: 15px;
}
.investment_li {
  margin-right: 15px;
}
.custom {
  margin: 5px;
  color: #4093e1;
  cursor: pointer;
}
.table_pagination {
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.box_warp {
  overflow-y: auto;
}
.end {
  justify-content: flex-end;
}
.sp_name {
  display: inline-block;
  font-size: 20px;
  margin: 10px 0px;
  margin-bottom: 20px;
  padding: 0 5px;
  border-left: 5px solid #0b2464;
}

.table_bottom{
  float: right;

  .bottom_btn{
    margin-top: 10px;
    flex: 1;

    .btn_first{
      margin-right: 10px;
    }
  }
}
</style>